import { render, staticRenderFns } from "./ConfigurationTemplateAddModal.vue?vue&type=template&id=4c4cb1e7&scoped=true"
import script from "./ConfigurationTemplateAddModal.vue?vue&type=script&lang=js"
export * from "./ConfigurationTemplateAddModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationTemplateAddModal.vue?vue&type=style&index=0&id=4c4cb1e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4cb1e7",
  null
  
)

export default component.exports